/**
 * Where the OLD pages send you now that the new experience is the live one (ACOP-140).
 *
 * Nothing about the old routes is cleaned up (David, 2026-10-13): somebody may have bookmarked them,
 * or follow an old email or citation link, so each one redirects rather than dying. The `-2` URLs
 * stay the real ones — the AVS OS KB and Home content link to /knowledge-base-2?article=… already.
 *
 * Pure and free of React/react-router imports so the mapping can be unit-tested directly — the same
 * reasoning as utils/nav.ts and utils/landing.ts. The caller keeps the query string and hash.
 */
export const LEGACY_ROUTE_REDIRECTS: Record<string, string> = {
  "/copilot": "/copilot-2",
  "/resources/knowledge-base": "/knowledge-base-2",
};

/** The new path for an old one, or null when `pathname` is not a retired route. Exact match only. */
export function legacyRedirectPath(pathname: string): string | null {
  return LEGACY_ROUTE_REDIRECTS[pathname] ?? null;
}
